<template>
  <div>
    <router-view :maximized="maximized"></router-view>
  </div>
</template>
<script>
(function($) {
  $(window).on("load", function() {
    $(".content").mCustomScrollbar();
  });
})(jQuery);
</script>
<script>
$('.switch input[type="checkbox"]').click(function() {
  if ($(this).prop("checked") == true) {
    $(".optionSelLeft").removeClass("active");
    $(".optionSelRight").addClass("active");
  } else if ($(this).prop("checked") == false) {
    $(".optionSelRight").removeClass("active");
    $(".optionSelLeft").addClass("active");
  }
});
</script>
<script>
import { Component, Prop, Vue } from "vue-property-decorator";

import { mapState, mapActions } from "vuex";

@Component()
export default class InspectionTemplate extends Vue {
  @Prop(Boolean) maximized;
  // get format(){
  //     return this.$route.params.format
  // }
  // get reportID(){
  //     return this.$route.params.reportID
  // }
  get template() {
    return this.$route.params.template;

    // if(this.$store.state.sampleInfo){
    //     return 'sample';
    // }
    // else if(this.$store.state.template){
    //     return 'info'
    // }
    // else if(this.$store.state.report){
    //     return 'report'
    // }
    // else{
    //     return 'template'
    // }
    // return 'template'
  }

  get sampleInfo() {
    return this.$store.state.sampleInfo;
  }
  openTemplate(e) {
    this.$store.dispatch("showNonEditableSamples", false);
    this.$store.dispatch("selectCommodity", "potato");
    // this.$store.dispatch("showTemplate");
    this.$router.push("/app/secure/inspectionTemplate/generalInfo/potato");
    this.$router.go();
  }
}
</script>
<style scoped>
.midSection .productSlider .carousel-control-prev,
.midSection .productSlider .carousel-control-next {
  bottom: -72px !important;
}

.midSection .productSlider {
  padding: 20px 20px 93px !important;
}

.midSection .navListLeft {
  height: 634px !important;
}

#demo.carousel {
  padding-bottom: 20px !important;
}

#demo .carousel-inner {
  padding-bottom: 10px !important;
}

.carousel-control-next-icon img,
.carousel-control-prev-icon img {
  vertical-align: top !important;
}

.midSection .productSlider .carousel-indicators .active {
  top: -3px !important;
}

.midSection .productSlider .carousel-indicators {
  bottom: -260px !important;
}
</style>